import { all, takeEvery, select } from 'redux-saga/effects'
import _ from 'lodash'
import log from 'loglevel'

import { SETUP_DISTRAINTS_BY_ID } from './constants'
import { sendMessage } from '../../../../services/socket/helpers'

import { hasAccessRightsToDistraints } from './selectors'

import config from '../../../../config'

import { SOCKET_ACTION_TYPE } from '../../../../services/socket/constants'

const MODULE_KEY = config.modules.distraints.key

function* onSetupDistraintsById(_action) {
    const distraintsId = _.get(_action, 'data.id', null)
    if (!distraintsId) return null

    const hasDistraintsAccessRights = yield select(hasAccessRightsToDistraints)
    if (config.iframeSolution && hasDistraintsAccessRights) {
        yield sendMessage(SOCKET_ACTION_TYPE.SHOW_MODULE_OUTPUT, { module: MODULE_KEY, entityId: distraintsId })
    } else {
        log.info(`Open distraints for id ${distraintsId} in new stack`)
    }
    return null
}

export default function* distraintsSaga() {
    yield all([takeEvery(SETUP_DISTRAINTS_BY_ID, onSetupDistraintsById)])
}
